import { render, staticRenderFns } from "./doubleRecipe.vue?vue&type=template&id=7aff15ca&scoped=true&"
import script from "./doubleRecipe.vue?vue&type=script&lang=js&"
export * from "./doubleRecipe.vue?vue&type=script&lang=js&"
import style0 from "./doubleRecipe.vue?vue&type=style&index=0&id=7aff15ca&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff15ca",
  null
  
)

export default component.exports